<template lang="pug">
  v-container.collection
    Breadcrumbs
    Heading(
      :title="collection.title"
      :description="collection.description"
    )
    v-card.mt-8(outlined)
      v-card-text
        v-data-iterator(:items="collection.datasets" :sort-by="orderBy")
          template(v-slot:header)
            v-row
              v-col.px-0(cols="12" sm="6" md="4" lg="3")
                v-select.mx-4(
                  v-model="orderBy"
                  solo
                  hide-details
                  :items="orderOptions"
                  label="Order by"
                )
          template(v-slot:default="props")
            v-row
              v-col.pa-0(v-for="item in props.items" :key="item.id" cols="12" sm="6" md="4" lg="3")
                Datacard(
                  :title="item.title"
                  :description="item.description"
                  :number-of-records="item.number_of_records"
                  :s3-details="item.s3_details"
                  :url="item.data_source"
                  :ext-url="item.external_url"
                  :dataset-id="item.id"
                  :to="{name:'dataset',params:{id:item.id}}"
                  rows="6"
                  show-details
                  show-nav
                ).ma-4
</template>

<script>
import moment from "moment";
import service from "../data/service";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Datacard from "@/components/Datacard.vue";
import Heading from "@/components/Heading.vue";

export default {
  data: () => ({
    collection: {},
    orderBy: "title",
    orderOptions: [
      {
        text: "Title",
        value: "title"
      },
      {
        text: "Last Updated",
        value: "invLastUpdateMs"
      },
      {
        text: "Number of Records",
        value: "number_of_records"
      }
    ]
  }),
  components: {
    Breadcrumbs,
    Datacard,
    Heading
  },
  methods: {
    getCollection() {
      return service.getCollection(this.$route.params.id).then(data => {
        data.datasets.forEach(dataset => {
          dataset.invLastUpdateMs = -moment(dataset.last_update).valueOf();
        });
        this.collection = data;
      });
    }
  },
  mounted() {
    this.getCollection();
  },
  watch: {
    $route() {
      this.getCollection();
    }
  }
};
</script>